// import React, { useState, useEffect, useRef } from "react";
// import dropdownicon from "../../Assets/Images/AssignUserToRole/dropdownicon.png";
// import { FULL_API_BASE_URL } from "../../Config/Config";

// const SchoolSearch = ({ onSchoolSelect }) => {
//   const [inputValue, setInputValue] = useState("");
//   const [schools, setSchools] = useState([]);
//   const [selectedSchoolName, setSelectedSchoolName] = useState("");
//   const dropdownRef = useRef(null);

//   const onChangeHandler = async (e) => {
//     const searchKey = e.target.value;
//     setInputValue(searchKey); // Update the input field value

//     if (searchKey.trim() === "") {
//       setSchools([]); // Clear the dropdown when input is empty
//     } else {
//       try {
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-schools-list/?search_key=${searchKey}`
//         );

//         if (response.ok) {
//           const data = await response.json();
//           setSchools(data); // Update the list of schools
//         } else {
//           console.error("Failed to fetch schools:", response.statusText);
//         }
//       } catch (error) {
//         console.error("Error fetching schools:", error);
//       }
//     }
//   };

//   const onSelectSchool = (school) => {
//     setSelectedSchoolName(school.school_name); // Set the selected school's name
//     setInputValue(school.school_name); // Update the input field with the selected school's name
//     onSchoolSelect(school); // Call the callback with the selected school
//     setSchools([]); // Clear the dropdown after selection
//   };

//   const handleClickOutside = (event) => {
//     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//       setSchools([]); // Close the dropdown if clicked outside
//     }
//   };

//   useEffect(() => {
//     // Add the event listener
//     document.addEventListener("mousedown", handleClickOutside);

//     return () => {
//       // Remove the event listener using the correct method
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   return (
//     <div style={{ position: "relative" }} ref={dropdownRef}>
//       <label style={{ fontSize: "14px", color: "#6A6A6A" }}>School Name <span style={{color: "red", marginRight: "5px"}}>*</span></label>
//       <div
//         className="aur-search-dropbtn"
//         style={{ width: "100%", backgroundColor: "white" }}
//       >
//         <input
//           type="text"
//           placeholder="Type here to Search..."
//           style={{ padding: "10px", width: "91%", height: "30px", color: "#6A6A6A" }}
//           value={inputValue} // Display the current input value
//           onChange={onChangeHandler} // Handle input changes
//           onClick={() => setSelectedSchoolName("")} // Allow input modification after selecting
//         />
//         <button
//           // onClick={()=>{onSearch("")}}
//           style={{
//             backgroundColor: "white",
//             border: "none",
//             height: "25px",
//             marginTop: "4px",
//           }}
//         >
//           <img src={dropdownicon} alt="" />
//         </button>
//       </div>

//       {schools.length > 0 && (
//         <div
//           style={{
//             position: "absolute", // Keep the dropdown from affecting layout
//             top: "100%", // Position right below the input
//             width: "100%",
//             border: "1px solid #ccc",
//             borderRadius: "4px",
//             maxHeight: "150px",
//             overflowY: "auto",
//             backgroundColor: "white",
//             zIndex: 1, // Ensure it appears on top
//           }}
//         >
//           {schools.map((school) => (
//             <div
//               key={school.school_id}
//               style={{
//                 padding: "10px",
//                 cursor: "pointer",
//                 backgroundColor: "white",
//                 borderBottom: "1px solid #eee",
//                 color: "#6A6A6A"
//               }}
//               onClick={() => onSelectSchool(school)}
//             >
//               {school.school_name}
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default SchoolSearch;

import React, { useState, useEffect, useRef } from "react";
import dropdownicon from "../../Assets/Images/AssignUserToRole/dropdownicon.png";
import { FULL_API_BASE_URL } from "../../Config/Config";

const SchoolSearch = ({
  onSchoolSelect,
  showError = false,
  isRequired = true,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [schools, setSchools] = useState([]);
  const [selectedSchoolName, setSelectedSchoolName] = useState("");
  const [selectedSchool, setSelectedSchool] = useState(null);
  const dropdownRef = useRef(null);

  const onChangeHandler = async (e) => {
    const searchKey = e.target.value;
    setInputValue(searchKey);
    setSelectedSchool(null); // Clear selected school when typing

    if (searchKey.trim() === "") {
      setSchools([]);
    } else {
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-schools-list/?search_key=${searchKey}`
        );

        if (response.ok) {
          const data = await response.json();
          setSchools(data);
        } else {
          console.error("Failed to fetch schools:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching schools:", error);
      }
    }
  };

  const onSelectSchool = (school) => {
    setSelectedSchoolName(school.school_name);
    setInputValue(school.school_name);
    setSelectedSchool(school);
    onSchoolSelect(school);
    setSchools([]);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setSchools([]);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Determine if should show error state
  const hasError = showError && isRequired && !selectedSchool && !inputValue;

  return (
    <div style={{ position: "relative" }} ref={dropdownRef}>
      <label style={{ fontSize: "14px", color: "#6A6A6A" }}>
        School Name <span style={{ color: "red", marginRight: "5px" }}>*</span>
      </label>
      <div
        className="aur-search-dropbtn"
        style={{
          width: "100%",
          backgroundColor: "white",
          border: hasError ? "1px solid #ff0000" : "1px solid gray",
          // borderRadius: "4px",
          display: "flex",
          alignItems: "center",
          transition: "border-color 0.3s ease",
        }}
      >
        <input
          type="text"
          placeholder="Type here to Search..."
          style={{
            padding: "10px",
            width: "91%",
            height: "30px",
            color: "#6A6A6A",
            border: "none",
            outline: "none",
            backgroundColor: "white",
          }}
          value={inputValue}
          onChange={onChangeHandler}
          onClick={() => setSelectedSchool(null)}
        />
        <button
          style={{
            backgroundColor: "white",
            border: "none",
            height: "25px",
            // marginTop: "4px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img src={dropdownicon} alt="dropdown" />
        </button>
      </div>

      {schools.length > 0 && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            width: "100%",
            border: "1px solid #ccc",
            // borderRadius: "4px",
            maxHeight: "150px",
            overflowY: "auto",
            backgroundColor: "white",
            zIndex: 1,
            marginTop: "4px",
          }}
        >
          {schools.map((school) => (
            <div
              key={school.school_id}
              style={{
                padding: "10px",
                cursor: "pointer",
                backgroundColor: "white",
                borderBottom: "1px solid #eee",
                color: "#6A6A6A",
                transition: "background-color 0.2s ease",
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#f5f5f5")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "white")}
              onClick={() => onSelectSchool(school)}
            >
              {school.school_name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SchoolSearch;
